<template>
  <v-flex v-if="companyChart" mt-5 class="white">
    <h4 class="text-15-security blue-security text-xs-center font-weight-bold pt-3">
      ORGANIGRAMA
    </h4>
    <br />
    <!-- Father -->
    <v-layout row wrap v-if="parents.father.length" justify-center>
      <v-flex xs12 sm12>
        <v-flex xs12 sm12 text-xs-left mb-2>
          <p class="mb-0 ml-4">JEFATURA</p>
        </v-flex>

        <CardUserChartMobile
          :user="parents.father[0]"
          widthCard="auto"
        />
      </v-flex>
    </v-layout>
    <!-- End Father -->

    <hr class="mb-2" />
    <!-- User and siblings -->
    <v-layout class row wrap justify-center>
      <v-flex md2 mr-2>
        <v-flex xs12 sm12 text-xs-left mb-2>
          <p class="mb-0 ml-4">RELACIONADOS</p>
        </v-flex>
        <CarouselUserMobile :users="siblings" positionChart="RELACIONADOS" />
      </v-flex>
    </v-layout>
    <!-- End selected_user and siblings -->
    <hr v-if="parents.childrens.length" class="mb-2" />
    <!-- Childrens -->
    <v-layout row wrap justify-center v-if="parents.childrens.length">
      <v-flex md2 mr-2>
        <v-flex xs12 sm12 text-xs-left mb-2>
          <p class="mb-0 ml-4">EQUIPO</p>
        </v-flex>
        <CarouselUserMobile :users="parents.childrens" positionChart="EQUIPO" />
      </v-flex>
    </v-layout>
    <!-- End Childrens -->
  </v-flex>
</template>

<script>
import CardUserFather from '@/components/User/CardUserFather';
import CardUserChartMobile from '@/components/User/CardUserChartMobile';
import CardUserSibling from '@/components/User/CardUserSibling';
import CardUserChildren from '@/components/User/CardUserChildren';
import CarouselUserMobile from '@/components/User/CarouselUserMobile';

export default {
  components: {
    CardUserFather,
    CardUserSibling,
    CardUserChildren,
    CardUserChartMobile,
    CarouselUserMobile,
  },
  props: {
    parents: {
      type: Object,
      required: false,
    },
    companyChart: {
      type: Boolean,
      required: true,
    },
    currentUser: {
      type: Object,
      required: false,
    }
  },
  computed: {
    siblings() {
      if (this.currentUser) {
        return [this.currentUser, ...this.parents.siblings]
      } else {
        return this.parents.siblings
      }
    }
  }
}
</script>